import ApplicationController from './application'

export default class extends ApplicationController {
  static values = { href: String }

  navigate(event) {
    if (event.target.closest('a, button, input, label, select, textarea, [data-row-link-ignore]')) return

    window.location.assign(this.hrefValue)
  }

  keyNavigate(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    this.navigate(event)
  }
}
